const a = "_table_aaja8_1", t = "_fixed_aaja8_7", _ = "_th_aaja8_10", e = "_td_aaja8_13", o = "_tbody_aaja8_25", c = "_thead_aaja8_35", i = "_tr_aaja8_39", n = "_sorter_aaja8_42", s = "_expander_aaja8_43", d = "_icon_aaja8_56", j = "_compact_aaja8_95", r = "_isMobileDivide_aaja8_102", l = "_isSpaceBetween_aaja8_136", p = {
  table: a,
  fixed: t,
  th: _,
  td: e,
  tbody: o,
  thead: c,
  tr: i,
  sorter: n,
  expander: s,
  icon: d,
  "icon-left": "_icon-left_aaja8_63",
  "icon-right": "_icon-right_aaja8_66",
  compact: j,
  isMobileDivide: r,
  isSpaceBetween: l
};
export {
  j as compact,
  p as default,
  s as expander,
  t as fixed,
  d as icon,
  r as isMobileDivide,
  l as isSpaceBetween,
  n as sorter,
  a as table,
  o as tbody,
  e as td,
  _ as th,
  c as thead,
  i as tr
};
//# sourceMappingURL=table.module.less.js.map
